import classNames from 'classnames';
import React from 'react';

export type TagTypes = 'beta';

export interface TagProps {
  id?: string;
  text: string;
  type: TagTypes;
}

const Tag: React.FC<TagProps> = ({ id, text, type }) => {
  return (
    <span id={id} className={classNames(['ui-tag', `ui-tag--${type}`])}>
      {text}
    </span>
  );
};

export default Tag;
